module.exports = __webpack_public_path__ + "static/media/logooo.11da8d0c.png";